var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-nav"},[_c('router-link',{staticClass:"logo",attrs:{"to":"/"}},[_c('img',{attrs:{"src":_vm.logo,"alt":"Profanitor"}})]),_c('div',{staticClass:"cta"},[_vm._t("cta")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }